<div class="gear">
  <nb-icon style="cursor: pointer" icon="settings-2-outline" [matMenuTriggerFor]="menu"/>

  <mat-menu #menu="matMenu" xPosition="before">
    <div class="change-table">
      <div class="section-menu">

        <p i18n="@@GridSettings">
          Настройка таблицы
          <nb-icon icon="sync-outline" style="cursor: pointer" (click)="tableService.reset()" nbTooltip="Сбросить настройки"/>
        </p>

        <div cdkDropListGroup>
          <div *ngFor="let column of tableService.getColumns(); let i= index" cdkDropList [cdkDropListData]="{index:i}" (cdkDropListDropped)="drop($event)">
            <nb-checkbox size="small" class="drag" [checked]="column.enabled" [disabled]="column.readonly" (change)="setColumn(column, !column.enabled)" cdkDrag>
              {{ column.title || 'col' }}
            </nb-checkbox>
          </div>
        </div>

        <ng-container *ngIf="tableService?.widgetTypes">
          <p i18n="@@Widget">Виджет</p>
          <nb-checkbox size="small" *ngFor="let widgetType of tableService?.widgetTypes" [checked]="isWidgetChecked(widgetType)" (checkedChange)="setWidget(widgetType, $event)">{{ widgetType.title }}</nb-checkbox>
        </ng-container>
      </div>
    </div>
  </mat-menu>
</div>
